export const MIN_SLOT_INTERVAL_MINUTES = 5;
export const DEFAULT_CALENDAR_GRID_ZOOM_MINUTES = 15;
export const CALENDAR_GRID_ZOOM_OPTIONS = [5, 15, 30, 60];

export function normalizeSlotIntervalMinutes(value, fallback = MIN_SLOT_INTERVAL_MINUTES) {
  const parsed = Number(value);
  const fallbackParsed = Number(fallback);
  const safeFallback = Number.isFinite(fallbackParsed) && fallbackParsed >= MIN_SLOT_INTERVAL_MINUTES
    ? Math.round(fallbackParsed)
    : MIN_SLOT_INTERVAL_MINUTES;
  if (!Number.isFinite(parsed)) return safeFallback;
  return Math.max(MIN_SLOT_INTERVAL_MINUTES, Math.round(parsed));
}

export function normalizeCalendarGridZoomMinutes(value) {
  const parsed = Number(value);
  return CALENDAR_GRID_ZOOM_OPTIONS.includes(parsed)
    ? parsed
    : DEFAULT_CALENDAR_GRID_ZOOM_MINUTES;
}

export function minuteOfDayFromTime(time) {
  const [hourRaw = "", minuteRaw = ""] = String(time || "").split(":");
  const hour = Number(hourRaw);
  const minute = Number(minuteRaw);
  if (!Number.isInteger(hour) || !Number.isInteger(minute)) return null;
  return hour * 60 + minute;
}

export function isTimeAlignedToSlotInterval(time, slotIntervalMinutes) {
  const minuteOfDay = minuteOfDayFromTime(time);
  if (minuteOfDay === null) return false;
  const interval = normalizeSlotIntervalMinutes(slotIntervalMinutes);
  return minuteOfDay % interval === 0;
}

export function buildCalendarTimeSlots({
  startHour = 7,
  endHour = 20,
  slotIntervalMinutes = MIN_SLOT_INTERVAL_MINUTES,
} = {}) {
  const interval = normalizeSlotIntervalMinutes(slotIntervalMinutes);
  const out = [];
  for (let h = startHour; h <= endHour; h += 1) {
    for (let m = 0; m < 60; m += interval) {
      if (h === endHour && m > 0) break;
      out.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
    }
  }
  return out;
}

export function alignMinutesToSlotInterval(value, slotIntervalMinutes) {
  const interval = normalizeSlotIntervalMinutes(slotIntervalMinutes);
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return interval;
  return Math.max(interval, Math.ceil(parsed / interval) * interval);
}

export function defaultDurationMinutes(settings, slotIntervalMinutes) {
  return alignMinutesToSlotInterval(settings?.default_duration_minutes, slotIntervalMinutes);
}

export function buildDurationOptions(slotIntervalMinutes, includeValues = [], maxMinutes = 180) {
  const interval = normalizeSlotIntervalMinutes(slotIntervalMinutes);
  const max = Math.max(interval, alignMinutesToSlotInterval(maxMinutes, interval));
  const values = new Set();
  for (let minutes = interval; minutes <= max; minutes += interval) {
    values.add(minutes);
  }
  for (const value of includeValues) {
    const parsed = Number(value);
    if (Number.isFinite(parsed) && parsed > 0) values.add(Math.round(parsed));
  }
  return Array.from(values).sort((a, b) => a - b);
}
